export default "__VITE_ASSET__OVNOGfxv__"